import { useEffect, useRef } from 'react';

/** Async actions may open their result only while they still own navigation.
 * Shared by the workspace, so a second action on another surface also wins. */
export function useNavigationIntent(scope: string) {
  const generation = useRef(0);
  const currentScope = useRef(scope);
  currentScope.current = scope;
  const active = useRef(true);
  useEffect(() => {
    active.current = true;
    return () => {
      active.current = false;
      generation.current++;
    };
  }, [scope]);
  return {
    cancel: () => {
      generation.current++;
    },
    begin: () => {
      const request = ++generation.current;
      const hash = location.hash;
      return () =>
        active.current &&
        currentScope.current === scope &&
        request === generation.current &&
        location.hash === hash;
    },
  };
}
